module.exports = __webpack_public_path__ + "static/media/vertigo2.36022c93.png";